var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export var CloseIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("title", { id: "close-icon" }, "Close Icon"),
    React.createElement("path", { d: "M12.7071068,12 L19.8535534,19.1464466 C20.0488155,19.3417088 20.0488155,19.6582912 19.8535534,19.8535534 C19.6582912,20.0488155 19.3417088,20.0488155 19.1464466,19.8535534 L12,12.7071068 L4.85355339,19.8535534 C4.65829124,20.0488155 4.34170876,20.0488155 4.14644661,19.8535534 C3.95118446,19.6582912 3.95118446,19.3417088 4.14644661,19.1464466 L11.2928932,12 L4.14644661,4.85355339 C3.95118446,4.65829124 3.95118446,4.34170876 4.14644661,4.14644661 C4.34170876,3.95118446 4.65829124,3.95118446 4.85355339,4.14644661 L12,11.2928932 L19.1464466,4.14644661 C19.3417088,3.95118446 19.6582912,3.95118446 19.8535534,4.14644661 C20.0488155,4.34170876 20.0488155,4.65829124 19.8535534,4.85355339 L12.7071068,12 Z" }))); };
//# sourceMappingURL=CloseIcon.js.map